module.exports = __webpack_public_path__ + "img/check.262b90f2.svg";